import {
  InsuranceCoverageMonitor,
  SetCoverageOnInsuranceCoverageMonitorRequest
} from "./types";
import { monitorService } from "./service";

export const setCoverageOnInsuranceCoverageMonitor = async (
  insuranceCoverageMonitorId: string,
  request: SetCoverageOnInsuranceCoverageMonitorRequest
): Promise<InsuranceCoverageMonitor> => {
  const { data } = await monitorService.patch<InsuranceCoverageMonitor>(
    `/${insuranceCoverageMonitorId}`,
    request
  );

  return data;
};
